<template>
    <div class="draft">
        <div class="title">草稿箱</div>
        
        <span placement="top" :class="['tooltip', { notclick:  !multipleSelection.length }]" content="刪除草稿" @click="delList()">
            <svg class="icon" aria-hidden="true">
                <use :xlink:href=" !multipleSelection.length ? '#iconshanchu1':'#iconshanchu1-copy'" />
            </svg>
            <span :class="{ 'btn-text': true, ban: !multipleSelection.length }">刪除草稿</span>
        </span>
        <div class="table">
            <!-- 文字列表 -->
            <div class="text-list">
                <el-table @selection-change="sortChange" :header-cell-style="{ background: 'rgba(80,181,255,0.15)', color: '#444' }" :data="draftList" empty-text="暫無數據" style="width: 100%">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column label="標題" width="250">
                        <template slot-scope="scope">
                            <span v-if="scope.row.titleCN">
                                {{ scope.row.titleCN }}
                            </span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="放盤類型" width="120">
                        <template slot-scope="scope">
                            <span v-if="scope.row.rentalType">
                                {{ scope.row.rentalType == 1 ? '放售' : '放租' }}
                            </span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="圖片" width="140">
                        <template slot-scope="scope">
                            <img :src="pub.imgResize(scope.row.imagePath, 'user')" onerror="errorImg(this,'property')" alt />
                        </template>
                    </el-table-column>

                    <el-table-column label="地區" width="150">
                        <template slot-scope="scope">
                            <span v-if="scope.row.zoneNameWithCulture">
                                {{ scope.row.zoneNameWithCulture }}
                            </span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="樓市片區" width="150">
                        <template slot-scope="scope">
                            <span v-if="scope.row.gscopeNameWithCulture">
                                {{ scope.row.gscopeNameWithCulture }}
                            </span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="分類" width="135">
                        <template slot-scope="scope">
                            <span v-if="scope.row.propertyCategoryWithCulture">
                                {{ scope.row.propertyCategoryWithCulture }}
                            </span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="售價(萬)" width="135">
                        <template slot-scope="scope">
                            <span v-if="scope.row.salePrice">{{ Math.round(scope.row.salePrice / 10000) }}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="租價(元)" width="135">
                        <template slot-scope="scope">
                            <span v-if="scope.row.rentPrice">{{ scope.row.rentPrice }}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="面積" min-width="150">
                        <template slot-scope="scope">
                            <p>
                                建築面積：
                                <span v-if="scope.row.buildingArea">
                                    {{ scope.row.buildingArea }}
                                </span>
                                <span v-else>-</span>
                            </p>
                            <p>
                                實用面積：
                                <span v-if="scope.row.saleableArea">
                                    {{ scope.row.saleableArea }}
                                </span>
                                <span v-else>-</span>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="建立時間" width="135">
                        <template slot-scope="scope">
                            <span v-if="scope.row.createTime">{{ scope.row.createTime.match(/(\S*)T/)[1] }}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="上次修改時間" width="135">
                        <template slot-scope="scope">
                            <span v-if="scope.row.updateTime">{{ scope.row.updateTime| getTime}}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" min-width="120">
                        <template slot-scope="scope">
                            <el-button @click="post(scope.row.draftID)" type="text">編輯</el-button>
                            <el-button @click="delList(scope.row.draftID,'single')" type="text">刪除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 圖片列表 -->
            <div class="footer">
                <!-- <span>當前查詢記錄：{{ draftList.length }}</span> -->
                <el-pagination class="page" background @size-change="sizeChange" :page-size="pageCount" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev, pager, next,jumper" @current-change="currentChange" :current-page.sync="pageIndex" :total="count"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'agent',
    data() {
        return {
            /**放盤類型 */
            count: 0,
            draftList: [],
            userInfo: [],
            pageCount: 10,
            pageIndex: 1,
            multipleSelection:[],
        };
    },
    created() {
        /**获取草稿数据 */
        this.loadDraftList();
    },
    methods: {
        sortChange(val){
            this.multipleSelection = val;
        },
        /**數據翻頁 */
        currentChange(pageIndex) {
            this.pageIndex = pageIndex;
            this.loadDraftList();
        },
        /**改变每页数据 */
        sizeChange(data) {
            this.pageCount = data;
            this.loadDraftList();
        },
        /**获取草稿数据 */
        loadDraftList() {
            this.axios
                .post(this.pub.getApi().SearchPropertyDraft, {
                    pageCount: this.pageCount,
                    pageIndex: this.pageIndex
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.count = res.data.result.count;
                        this.draftList = res.data.result.data;
                        // 最后一页删除后 回到前一页
                        if(this.count && this.pageIndex > Math.ceil(this.count /this.pageCount) ){
                            this.pageIndex = Math.ceil(this.count /this.pageCount);
                            this.loadDraftList()
                        }
                    }
                });
        },
        /* 获取当前用户信息*/
        GetUserInfo() {
            this.axios.get(this.pub.getApi().GetUserInfo).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.userInfo = res.data.result;
                    /**獲取草稿箱列表 */
                    if (localStorage.getItem(`draftList${this.userInfo.accountID}${this.userInfo.departmentID}`)) {
                        this.draftList = JSON.parse(localStorage.getItem(`draftList${this.userInfo.accountID}${this.userInfo.departmentID}`));
                    } else {
                        this.draftList = [];
                    }
                }
            });
        },
        /**進入放盤 */
        post(index) {
            this.$router.push({
                path: '/property/post',
                query: {
                    draftID: index
                }
            });
        },
        /**刪除草稿箱 */
        delList(index,type) {
            let draftidList = []
            if(this.multipleSelection && this.multipleSelection.length){
                for (let i = 0; i < this.multipleSelection.length; i++) {
                    draftidList.push(this.multipleSelection[i].draftID)  
                }
            }
            if(!draftidList.length && !index){
                this.$message({
                    showClose: true,
                    type: 'warning',
                    message: '請選擇要刪除的草稿'
                });
                return
            }
            /**删除当前记录 */
            this.$confirm('確定要刪除嗎', '提示', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    /**删除草稿箱 */
                    this.axios
                        .post(this.pub.getApi().RemovePropertyDraft, {
                            draftID: type=='single' ?  [index] : draftidList
                        })
                        .then(res => {
                            if (res.data.code === 0 && res.data.result) {
                                this.$message({
                                    showClose: true,
                                    message: '刪除成功',
                                    type: 'success'
                                });
                                this.loadDraftList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        type: 'warning',
                        message: '已取消操作'
                    });
                });
        }
    }
};
</script>

<style lang="less">
.draft {
    .icon {
        width: 27px;
        height: 23px;
        cursor: pointer;
    }
    .btn-text {
        cursor: pointer;
        position: relative;
        top: 0px;
        font-size: 15px;
        padding-left: 5px;
        color: #0062ff;
    }
    .ban {
        color: #666;
    }
    /* 按钮样式 */
    .el-button {
        height: 38px;
        // width: 95px;
    }
    background-color: #f3f3f5;
    padding: 0;
    margin: 0;
    padding: 0 20px 20px 20px;
    text-align: left;
    .title {
        padding: 20px 0;
        font-size: 24px;
        color: #171725;
    }
    .table {
        .el-button {
            text-align: left;
            // width: 100%;
        }
        margin-top: 28px;
        table,
        tr,
        td,
        th {
            border: none;
        }
        .el-table tbody tr:hover > td {
            background-color: rgba(80, 181, 255, 0.1) !important;
        }
        /deep/ .el-table thead tr {
            th:first-child {
                border-radius: 10px 0 0 10px;
            }
            th:nth-last-child(2) {
                border-radius: 0 10px 10px 0;
            }
        }
        .el-table__header tr,
        .el-table__header th {
            padding: 0;
            height: 38px;
        }
        .el-table th {
            border: none;
        }
        .el-table td {
            border-bottom: 1px solid #e2e2ea;
        }
        table {
            color: #222;
            font-size: 14px;
            tr th .cell {
                font-weight: normal;
                font-size: 12px;
                color: #44444f;
            }
        }
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 20px;
        padding: 20px;
        box-sizing: border-box;
        .text-list {
            img {
                /**背景圖 */
                background-image: url('//static.house730.com/m/images/staff-default.png');
                background-size: 100% 100%;
                width: 50px;
                height: 50px;
                display: block;
            }
        }
        .footer {
            span {
                font-size: 14px;
                color: #44444f;

                margin-left: 16px;
            }
            margin-top: 16px;
            padding-top: 20px;
            box-sizing: border-box;
            height: 72px;
            .page {
                float: right;
            }
            .input-number {
                text-align: left;
                float: right;
                width: 70px;
            }
            /**覆盖计数器样式 */
            .el-input-number.is-controls-right .el-input__inner {
                padding-left: 8px;
                padding-right: 42px;
            }
        }
    }
}
</style>
